import { render, staticRenderFns } from "./StatusTrafficLight.vue?vue&type=template&id=643e393b&scoped=true"
import script from "./StatusTrafficLight.vue?vue&type=script&lang=js"
export * from "./StatusTrafficLight.vue?vue&type=script&lang=js"
import style0 from "./StatusTrafficLight.vue?vue&type=style&index=0&id=643e393b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e393b",
  null
  
)

export default component.exports